<template>
  <div id="app">
    <Navbar class="z-index-3000" />
    <div v-if="!dataIsLoaded">
      <div class="spinner-border loading" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      loading ....
    </div>

    <router-view v-else />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import { getDatabase } from "./common/dataSourceIntegrationService";
export default {
  components: { Navbar },
  data() {
    return { dataIsLoaded: false, currentEnv: process.env.VUE_APP_ENV };
  },
  created() {
    getDatabase()
      .then(resp => {
        this.$store.commit("createDatabase", resp.data);
        this.dataIsLoaded = true;
      })
      .catch(err => {
        console.log(err);
        this.dataIsLoaded = true;
        this.$router.push({ name: "notFound" });
      });
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");
@import "@/common/style.scss";
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
.loading {
  width: 10rem;
  height: 10rem;
  color: green;
}
</style>
